<template>
  <div class="triggle_scl de_triggle_scl">
    <div
      v-for="(item, index) in list"
      :key="'g' + index"
      class="triggle_list"
      :class="{ triggle_cur: item.ischeck }"
      :style="item.IsShow==true?'':'display:none'"
    >
      <div class="triggle_line clearfix">
        <em
          class="triggle_more"
          @click="onCheck(item, index)"
        />
        <span class="triggle_span">{{ item.Desc }}</span>
        <div
          v-if="getIftttShowMode(item)"
          class="triggle_left"
        >
          <!-- <div class="triggle_left" v-if="item.ShowMode==1||item.ShowMode==3"> -->
          <div
            v-for="(model, t) in item.Values"
            :key="'b' + t"
            class="triggle_div"
            style="width:100%"
          >
            <div
              v-if="model.IsShow"
              class="triggle_ctr"
            >
              <div class="triggle_div2">
                <template v-if="model.ValueType == 'UIControl_Switch'">
                  <el-switch
                    v-model="model.DefaultValue"
                    class="triggle_switch"
                    active-color="#7dacee"
                    inactive-color="#d9e2f0"
                    :active-value="1"
                    :inactive-value="0"
                  />
                </template>
                <template v-if="model.ValueType == 'UIControl_Radio_Baoli'">
                  <el-radio-group
                    v-for="(_item, _index) in model.EnumValue"
                    :key="_index"
                    v-model="model.DefaultValue"
                  >
                    <el-radio :label="_item.Value">
                      {{ _item.Name }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-if="model.ValueType == 'UIControl_ColorTemperature'">
                  <img
                    class="triggle_img1"
                    src="@/assets/img/icon_set-01.png"
                  >
                  <div class="triggle_slider">
                    <el-slider
                      v-model="model.DefaultValue"
                      :min="model.Min"
                      :max="model.Max"
                      class="color_add"
                    />
                  </div>
                  <img
                    class="triggle_img2"
                    src="@/assets/img/icon_set-02.png"
                  >
                  <span style="position: absolute;display: inline-block;padding-left: 10px;padding-left: 46px;font-size: 12px;">k</span>
                  <el-input-number
                    v-model="model.DefaultValue"
                    class="input_number_action"
                    :min="model.Min"
                    :max="model.Max"
                    style="padding:0;width: 50px;height:24px"
                  />
                </template>
                <template v-if="model.ValueType == 'UIControl_Bright'">
                  <img
                    class="triggle_img1"
                    src="@/assets/img/icon_set-03.png"
                  >
                  <div class="triggle_slider">
                    <el-slider
                      v-model="model.DefaultValue"
                      :min="model.Min"
                      :max="100"
                      class="light_add"
                    />
                  </div>
                  <img
                    class="triggle_img2"
                    src="@/assets/img/icon_set-04.png"
                  >
                  <span style="position: absolute;display: inline-block;padding-left: 10px;padding-left: 42px;font-size: 12px;">%</span>
                  <el-input-number
                    v-model="model.DefaultValue"
                    class="input_number_action nopadding"
                    :min="1"
                    :max="100"
                    :precision="0"
                    style="padding:0;width: 50px;height:24px"
                  />
                </template>
                <template v-if="model.ValueType == 'UIControl_UpAndDown'">
                  <template v-for="(enumValue,ind) in model.EnumValue">
                    <button
                      :key="ind"
                      class="warm_button warm_button_left"
                      :class="model.DefaultValue == enumValue.Value?'warm_button_select':''"
                      @click.stop="steppingactionclick(item, model, enumValue.Value)"
                    >
                      {{ enumValue.Name }}
                    </button>
                  </template>
                </template>
                <template v-if="model.ValueType == 'UIControl_CCT'">
                  <template v-for="(enumValue,ind) in model.EnumValue">
                    <button
                      :key="ind"
                      class="warm_button warm_button_left"
                      :class="model.DefaultValue == enumValue.Value?'warm_button_select':''"
                      @click.stop="steppingactionclick(item, model, enumValue.Value)"
                    >
                      {{ enumValue.Name }}
                    </button>
                  </template>
                </template>
                <template v-if="model.ValueType == 'UIControl_Color'">
                  <el-color-picker
                    v-model="model.DefaultValue"
                    class="pick_color"
                  />
                </template>
                <template v-if="model.ValueType == 'UIControl_Scene_Baoli'">
                  <el-select v-model="model.DefaultValue" :placeholder="$t('deviceVirtual.placeholderone')">
                    <el-option
                      v-for="child of model.EnumValue"
                      :key="child.SceneId"
                      :label="child.Name"
                      :value="child.SceneId"
                    />
                  </el-select>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {isMatched,getIftttShowMode,getClassSkuAndVersion} from '@/utils/utils'
export default {
  props:{
    list:{
      type:Array,
      default:()=>[]
    }
  },
  methods:{
    getIftttShowMode,
    onCheck(item, index) {
      this.$emit('check', item, index)
    },
    steppingactionclick (fmodel, model, _type) {
      model.DefaultValue = _type
    },
  }
}
</script>

<style lang="scss" scoped>
.warm_button_select {
  color: #ffffff;
  background: #619df1;
}
</style>